const AppVersion: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <div id="app-version" className="hidden">
      {(process.env.APP_VERSION || process.env.NEXT_PUBLIC_APP_VERSION) ??
        'none'}
    </div>
  );
};

export default AppVersion;
